import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=442befa8&scoped=true&"
import script from "./privacy.vue?vue&type=script&lang=ts&"
export * from "./privacy.vue?vue&type=script&lang=ts&"
import style0 from "./privacy.vue?vue&type=style&index=0&id=442befa8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442befa8",
  null
  
)

export default component.exports